import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { catchError, finalize, tap } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { UserMetricGroupStore } from './user-metric-groups.store';
import { getErrorMessage } from '../../../modules/shared/get-error-mesage';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SignalStoreCache } from '../../../modules/shared/signal-store';

const STORE_NAME = 'user-metric-groups';

@Injectable({ providedIn: 'root' })
export class UserMetricGroupService {
  private umgStore = inject(UserMetricGroupStore);
  private cache = inject(SignalStoreCache);

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar
  ) {}

  getAll() {
    if (this.umgStore.loaded()) return EMPTY;
    // Always fetched from the API on page load (no IndexedDB cache), so admin changes show after a reload.
    this.umgStore.setLoading(true);
    return this.http.get<string[]>(`${environment.directoryApi}/user/metric_groups`).pipe(
      tap(x => this.umgStore.setAll(x.map(y => ({ id: y })))),
      catchError(err => of(this.snackBar.open(getErrorMessage(err), 'OK', { panelClass: 'red-snackbar' }))),
      finalize(() => this.umgStore.setLoading(false))
    );
  }

  async refreshCache(): Promise<void> {
    // Invalidate IndexedDB first — once `loaded` drops, a concurrent
    // getAll() may re-fetch and must not hit the stale cache entry
    await this.cache.invalidate(STORE_NAME);
    this.umgStore.resetCache();
  }
}
